import mixins from "./mixins";

const theme = {
  fontPrimary: `'Rubik', sans-serif`,
  fontSecondary: `'Raleway', sans-serif`,

  fontRegular: 400,
  fontBold: 700,
  fontExtra: 800,

  sizeBase: "16px",
  sizeBigest: "2.75rem",
  sizeBig: "2.25rem",
  sizeSmall: "0.75rem",
  sizeSmaller: "0.6875rem",
  sizeSmallest: "0.5625rem",

  lineHParagraphs: "16.62px",
  lineHBigTitles: "55.44px",
  lineHMediumTitle: "42.66px",
  lineHNormalTitle: "22.16px",

  colorPrimary: "#1D957F",
  colorPrimaryAlt: "#19806D",
  colorSecondary: "#4285F4",
  colorText: "#000000",
  colorTextAccent: "#616161",
  colorBg: "#FFFFFF",
  colorBgAccent: "#FAFBFD",

  boxShadow: `0 4px 18px rgba(88,126,236,0.18)`,
  boxShadowAlt: `0 2px 24px rgba(88,126,236,0.15)`,

  shadowPhone: `0 8px 8px rgba(0,0,0,0.25)`,

  mixins,
};

export default theme;
